import { BasicLayout } from '@/components/layouts';
import permissionConst from '@/utils/const/permission';

export default {
  path: '/my-config',
  name: 'MyConfig',
  component: BasicLayout,
  redirectToChild: true,
  meta: {
    title: '配置管理',
    authorities: permissionConst.manager,
  },
  children: [
    {
      path: '/my-config/message-push',
      name: 'MYConfig.MessagePush',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-config/MessagePush.vue'),
      meta: {
        title: '消息推送配置',
        icon: 'icon-wodefuwu',
      },
    },
  ],
};
